import Vue from 'vue';
import Vuex from 'vuex';
import { landing } from './landing/index';

Vue.use(Vuex);

export interface RootState {
  version: string;
  showExtraOption: boolean;
}

export default new Vuex.Store({
  state: { version: '1.0.0', showExtraOption: false },
  modules: { landing },
});
